import React from 'react'

import { Button } from 'src/chrome'

import Iframe from '../Iframe'

import videoStyles from '../VideoSection/videoSection.module.scss'
import styles from './hero.module.scss'

interface CallToAction {
  title: string
  action: () => void
}

interface HeroProps {
  title: string
  titleStyle?: React.CSSProperties
  copy: string
  extendedCopy?: string
  image?: string
  video?: string
  callToAction?: CallToAction
  buttonColor?: React.CSSProperties
  loop?: boolean
  autoPlay?: boolean
  withIframe?: boolean
  pricingComponent?: React.ReactChild
  style?: React.CSSProperties
}

const HeroSection: React.FC<HeroProps> = props => {
  const {
    title,
    titleStyle,
    copy,
    extendedCopy,
    image,
    video,
    callToAction,
    buttonColor,
    loop,
    autoPlay,
    withIframe,
    pricingComponent,
    style,
  } = props
  return (
    <div className={styles.hero} style={style}>
      <div className={styles.container}>
        <div className={styles.heroInner}>
          <div className={styles.heroCopy}>
            <h1 style={titleStyle}>{title}</h1>
            {pricingComponent}
            <p className={styles.heroParagraph}>{copy}</p>
            {extendedCopy && (
              <p className={styles.heroParagraph}>{extendedCopy}</p>
            )}
            {callToAction && (
              <p className={styles.heroCta}>
                <Button
                  buttonColor={!buttonColor ? 'pink' : undefined}
                  title={callToAction.title ? callToAction.title : 'Continue'}
                  onClick={callToAction.action}
                  className={styles.cta}
                  style={buttonColor}
                />
              </p>
            )}
          </div>
          <div className={styles.heroIllustration}>
            {image && <img src={image} alt={'Hero Animation'} />}
            {video && (
              <div
                className={
                  withIframe
                    ? `${videoStyles.videoBlock} ${videoStyles.iframe} ${videoStyles.bg}`
                    : `${videoStyles.videoBlock} ${videoStyles.bg}`
                }
              >
                {!withIframe && (
                  <video
                    controls={true}
                    loop={loop}
                    src={video}
                    autoPlay={autoPlay}
                  />
                )}
                {withIframe && <Iframe src={video} />}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeroSection
